<script setup lang="ts">
import { ref } from 'vue';

import type { TextEditorPreviewIframe } from './types';

defineProps<TextEditorPreviewIframe>();

const iframe = ref<HTMLIFrameElement>();
const iframeHeight = ref(0);
function onFrameLoaded(): void {
  iframeHeight.value = iframe.value?.contentDocument?.body.offsetHeight ?? 0;
}
</script>

<template>
  <div v-data-qa-auto-id="'TextEditorPreviewIframe'">
    <div
      class="mb-2 block text-muted-color"
    >
      {{ label }}
    </div>
    <iframe
      ref="iframe"
      title="text-editor preview"
      class="w-full border p-4"
      :height="iframeHeight + 50"
      :srcdoc="html"
      @load="onFrameLoaded"
    />
  </div>
</template>
